'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');

/**
 * Hide customized order summary and show the estimate price trigger.
 *
 * @returns {void}
 */
function resetEstimateDisplay() {
    $('.customized-order-summary').addClass('d-none');
    $('.approx-estimate-price').removeClass('d-none');
}

/**
 * Sends customized order form data to the server,
 * calculates the approximate price and delivery date,
 * and updates the UI with the returned values.
 *
 * - Serializes form data
 * - Calls backend via AJAX (POST)
 * - Updates price, delivery date, and hidden fields
 * - Shows order summary section
 * - Displays error notification if calculation fails
 *
 * @function calculateAndUpdateCustomOrderDetails
 * @returns {void}
 */
function calculateAndUpdateCustomOrderDetails() {
    var $form = $('#customize-order-form');
    var formData = $form.serialize() + '&productId=' + $('input[name="productId"]').val();
    var url = $form.attr('action');
    var $pricetimeout = $('.approx-estimate-price');
    var estimatetimeout = $pricetimeout.data('estimate-timeout');

    $.ajax({
        url: url,
        method: 'POST',
        data: formData,
        success: function (data) {
            if (!data.error) {
                $('.custom-dynamic-price').text('₹' + data.approximatePrice);
                $('.customize-expected-delivery').text(data.customDeliveryDate);
                $('input[name="customProductPrice"]').val(data.approximatePrice);
                $('.customized-order-summary').removeClass('d-none');
                $('.approx-estimate-price').addClass('d-none');
                $('.product-details, .price-breakup').addClass('d-none');
                $('.price-and-details-wrapper .price-details').addClass('d-none');
            } else {
                var errorTitle = (data && data.message) ? data.message : estimatetimeout;
                toastMessageHelper.showNotification(errorTitle, null, null);
            }
        },
        error: function () {
            // console.log('Error calculating price. Please try again.' + err);
        }
    });
}

/**
 * Collects all user-entered values from the customize order form
 * and stores them in sessionStorage.
 *
 * - Reads input and textarea values (excluding hidden fields)
 * - Stores checkbox values as boolean
 * - Extracts selected values from custom dropdown components
 * - Validates dropdown selection before saving
 * - Saves data as JSON in sessionStorage under
 *   'ckc_customizeOrderFormData'
 *
 * @function saveCustomOrderForm
 * @returns {void}
 */
function saveCustomOrderForm() {
    var formData = {};
    $('#customize-order-form input, #customize-order-form textarea').each(function () {
        var id = $(this).attr('id');
        if (!id) return;
        if ($(this).attr('type') === 'checkbox') {
            formData[id] = $(this).is(':checked');
        } else if ($(this).attr('type') !== 'hidden') {
            formData[id] = $(this).val();
        }
    });

    $('#customize-order-form .custom-drop-down-section').each(function () {
        var $wrapper = $(this);
        var $selectedValue = $wrapper.find('.selected-value');
        var value = $selectedValue.text().trim();
        var $select = $wrapper.closest('.form-group').find('select');
        var id = $select.attr('id');

        if (id && value) {
            var isValidOption = false;
            $wrapper.find('.custom-option-value').each(function () {
                if ($(this).text().trim() === value) {
                    isValidOption = true;
                    return false;
                }
                return true;
            });
            if (isValidOption) {
                formData[id] = value;
            }
        }
    });

    try {
        window.sessionStorage.setItem('ckc_customizeOrderFormData', JSON.stringify(formData));
    } catch (e) {
        // ignore
    }
}

/**
 * Restores customize order form data from sessionStorage
 * and repopulates the form fields.
 *
 * - Retrieves saved JSON data from 'ckc_customizeOrderFormData'
 * - Parses and removes stored data from sessionStorage
 * - Restores checkbox, input, textarea, and select values
 * - Syncs custom dropdown UI with restored select values
 * - Resets estimate display and recalculates pricing
 *
 * @function restoreCustomOrderForm
 * @returns {void}
 */
function restoreCustomOrderForm() {
    var dataStr;
    try {
        dataStr = window.sessionStorage.getItem('ckc_customizeOrderFormData');
    } catch (e) {
        return;
    }

    if (!dataStr) return;

    try {
        var formData = JSON.parse(dataStr);
        window.sessionStorage.removeItem('ckc_customizeOrderFormData');

        Object.keys(formData).forEach(function (key) {
            var value = formData[key];
            var $el = $('#' + key);

            if ($el.length === 0) return;

            if ($el.is(':checkbox')) {
                $el.prop('checked', value);
            } else if ($el.is('textarea') || ($el.is('input') && $el.attr('type') !== 'hidden')) {
                $el.val(value);
            } else if ($el.is('select')) {
                $el.val(value);
                var $wrapper = $el.closest('.form-group').find('.custom-drop-down-section');
                if ($wrapper.length) {
                    var $option = $wrapper.find('.custom-option-value').filter(function () {
                        return $(this).text().trim() === value;
                    });
                    if ($option.length) {
                        $wrapper.find('.selected-value').text(value).addClass('active');
                        $wrapper.find('.custom-option-value').removeClass('selected active');
                        $option.addClass('selected active');
                    }
                }
            }
        });
        resetEstimateDisplay();
        calculateAndUpdateCustomOrderDetails();
    } catch (e) {
        // ignore
    }
}

$(document).ready(function () {
    $('#accept-terms-and-conditions').prop('checked', false);
    restoreCustomOrderForm();
    // Allow only numbers in Product Net Weight input
    $('.product-net-weight-and-length-wrapper').on('input', '#product-net-weight', function () {
        if ($('#product-net-weight').val() === '') {
            let weightMissingError = $('#product-net-weight').data('missing-error');
            $('.invalid-feedback.product-weight-error').text(weightMissingError).addClass('d-block');
            return;
        }
        $('.invalid-feedback.product-weight-error').text('').removeClass('d-block');
        const match = this.value.match(/^\d+(\.\d{0,2})?/);
        this.value = match ? match[0] : '';
        let lessWeighterrorMSg = $('#product-net-weight').data('less-weight-error');
        var currentValue = parseFloat($(this).val()) || 0;
        var minValue = parseFloat($('.min-net-weight-product').val()) || 0;
        if (currentValue < minValue && $('#product-net-weight').val() !== '') {
            $('.invalid-feedback.product-weight-error').text(lessWeighterrorMSg).addClass('d-block');
        }
    });
});

// Reset estimate display when any input value changes
$(document).on('input change', '#customize-order-form input, #customize-order-form textarea, #customize-order-form select', function () {
    resetEstimateDisplay();
});

/**
 * Handle dropdown selections (LENGTH)
 */
$('.product-net-weight-and-length-wrapper').on('click', '.custom-option-value', function () {
    var selectedText = $(this).text();

    // set hidden select value
    $('#productLengthDropDown').val(selectedText);

    // update UI
    $(this).closest('.custom-drop-down-section').find('.selected-value').text(selectedText)
        .addClass('active');
    $('.invalid-feedback.length-error').text('').removeClass('d-block');
    resetEstimateDisplay();
});

/**
 * Handle dropdown selections (POLISH TYPE)
 */
$('.custom-drop-down-section').on('click', '.custom-option-value.polish-type-option', function () {
    var selectedText = $(this).data('id');

    // set hidden select value
    $('#polish').val(selectedText);

    // update UI
    $(this).closest('.custom-drop-down-section').find('.selected-value').text(selectedText);
    resetEstimateDisplay();
});

// Better Requirement textarea validation (max 500 words)
$('.form-group.requirement').on('input', '#better-requiremnet', function () {
    let text = $(this).val().trim();
    let words = text.split(/\s+/).filter(Boolean);

    if (words.length > 500) {
        $(this).val(words.slice(0, 500).join(' ')); // trim to 500 words
        words = words.slice(0, 500);
    }

    // Update remaining word count
    $('.max-words').text((500 - words.length) + ' words left');
});

// Form Submission Validation
var customOrderForm = '.customize-order-form';
$(customOrderForm).on('submit', function (e) {
    e.preventDefault();
    if ($('.customiZedCountry').val() !== 'INR') {
        $('#currencychangecustomizationrestrictionmodal').modal('show');
        return;
    }

    let isValid = true;
    // Validate Terms & Conditions checkbox
    if (!$('#accept-terms-and-conditions').is(':checked')) {
        let missingError = $('#accept-terms-and-conditions').data('missing-error');
        $('.invalid-feedback.terms-and-conditions').text(missingError).addClass('d-block');
        isValid = false;
    } else {
        $('.invalid-feedback.terms-and-conditions').text('').addClass('d-none');
    }

    //  Validate Product Net Weight
    let weightMissingError = $('#product-net-weight').data('missing-error');
    let productWeight = $('#product-net-weight').val().trim();
    if (productWeight === '') {
        $('.invalid-feedback.product-weight-error')
            .text(weightMissingError)
            .addClass('d-block');
        isValid = false;
    } else {
        $('.invalid-feedback.product-weight-error').text('').removeClass('d-block');
    }
    let lessWeighterrorMSg = $('#product-net-weight').data('less-weight-error');
    var currentValue = parseFloat(productWeight) || 0;
    var minValue = parseFloat($('.min-net-weight-product').val()) || 0;
    if (currentValue < minValue && $('#product-net-weight').val() !== '') {
        $('.invalid-feedback.product-weight-error').text(lessWeighterrorMSg).addClass('d-block');
        isValid = false;
    }

    if ($('#productSizeDropDown').length || $('#productLengthDropDown').length) {
        //  Validate Product Length (from hidden select)
        let lengthMissingError = $('#productLengthDropDown').data('missing-error');
        let sizeMissingError = $('#productSizeDropDown').data('missing-error');
        let productLength = $('.product-length .selected-value.active').length;
        let productSize = $('.product-size .selected-value.active').length;
        if (productLength || productSize) {
            $('.invalid-feedback.length-error, .invalid-feedback.size-error').text('').removeClass('d-block');
        } else {
            $('.invalid-feedback.length-error').text(lengthMissingError).addClass('d-block');
            $('.invalid-feedback.size-error').text(sizeMissingError).addClass('d-block');
            isValid = false;
        }
    }

    //  Stop form submission if validation fails
    if (!isValid) {
        return;
    }

    if ($('.isLoggedInUser').length === 0) {
        saveCustomOrderForm();
        $('#ckc-login-modal').modal('show');

        var $wrap = $('.ckc-login-countrycode-drop-down');
        $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
        var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');
        $defaultOption.addClass('active selected');
        $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
        $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');

        $('.country-select-wrap').addClass('d-none');
        $('#loginInput').addClass('w-100');
        $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
        return;
    }

    calculateAndUpdateCustomOrderDetails();
});

$('.custom-confirm-order').on('click', function () {
    let isValid = true;

    if (!$('#accept-terms-and-conditions').is(':checked')) {
        let missingError = $('#accept-terms-and-conditions').data('missing-error');
        $('.invalid-feedback.terms-and-conditions').text(missingError).addClass('d-block');
        return;
    }
    //  Validate Product Net Weight
    let weightMissingError = $('#product-net-weight').data('missing-error');
    let productWeight = $('#product-net-weight').val().trim();
    if (productWeight === '') {
        $('.invalid-feedback.product-weight-error')
            .text(weightMissingError)
            .addClass('d-block');
        isValid = false;
    } else {
        $('.invalid-feedback.product-weight-error').text('').removeClass('d-block');
    }

    //  Stop form submission if validation fails
    if (!isValid) {
        return;
    }
    var reqData = {
        productId: $('input[name="productId"]').val(),
        price: $('input[name="customProductPrice"]').val(),
        isCustomizable: true
    };

    $.ajax({
        url: $('.custom-confirm-order').attr('data-href'),
        data: reqData,
        success: function (data) {
            // Handle successful confirmation
            if (data.success && data.redirect && data.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
        },
        error: function () {
            // console.log('Error while confirming Order. Please try again.' + err);
        }
    });
});

// Handle checkbox click
$('#accept-terms-and-conditions, .terms-and-conditions-label').on('click', function (e) {
    if (!$('#accept-terms-and-conditions').prop('checked')) {
        // If user is trying to check -> stop default and open modal
        e.preventDefault();
        e.stopPropagation();
        $('#terms-modal').modal('show');
    } else {
        // If already checked and user is unchecking -> allow it (no modal)
        $('#accept-terms-and-conditions').prop('checked', false);
    }
    // If already checked and user is unchecking -> allow it (no modal)
});

// "Close" button inside modal -> check the checkbox
$('#agree-btn').on('click', function () {
    $('#accept-terms-and-conditions').prop('checked', true);
    $('.invalid-feedback.terms-and-conditions').text('').addClass('d-none'); // Clear error messages
    $('#terms-modal').modal('hide');
});

